import { MortgageSimulation, MortgageSimulationPaymentTerm, MortgageSimulationType } from './mortgage-simulation.model';

export enum MortgageSimulatorStep {
  SimulationType = 1,
  SimulationData = 2,
  ContactData = 3,
  /* TODO: Uncomment when remodeling amount is available
  RemodelingAmount = 3,
  ContactData = 4,
  */
}

export type LocalMortgageSimulation = Pick<MortgageSimulation, 'amountNeeded' | 'downMortgage' | 'email' | 'fullName' | 'phoneNumber' | 'propertyValue' | 'remodelingExtraAmount'> & {
  paymentTerm: MortgageSimulationPaymentTerm | null;
  stepsCompleted: MortgageSimulatorStep[];
  type: MortgageSimulationType | null;
};

export const emptyMortgageSimulation: LocalMortgageSimulation = {
  amountNeeded: 0,
  downMortgage: 0,
  email: '',
  fullName: '',
  paymentTerm: null,
  phoneNumber: '',
  propertyValue: 0,
  remodelingExtraAmount: 0,
  stepsCompleted: [],
  type: null,
};